import React, { memo, useMemo, useRef } from 'react'
import { createPortal } from 'react-dom'

export const useInfoWindowPortal = () => {
  const containerRef = useRef(document.createElement('div'))
  const InfoWindow = useMemo(
    () =>
      memo(({ children }) => {
        return createPortal(children, containerRef.current)
      }),
    []
  )

  return { InfoWindow, containerRef }
}

export const useUserMarkerPortal = (count) => {
  const containerRef = useRef([])

  if (count > containerRef.current.length) {
    const doms = Array.from({
      length: count - containerRef.current.length,
    }).map(() => document.createElement('div'))
    containerRef.current.push(...doms)
  }

  const Markers = useMemo(
    () =>
      memo(({ children }) => {
        return (
          <>
            {children.map((child, i) =>
              createPortal(child, containerRef.current[i])
            )}
          </>
        )
      }),
    []
  )

  return { Markers, containerRef }
}
